<template>
    <MiscLink :to="getConfig?.link?.value" class="flex flex-col h-full">
        <div class="flex gap-4 items-center md:flex-col md:items-start">
            <div v-if="getConfig?.iconName?.value" class="p-3">
                <MiscIcon
                    class="w-[66px] h-auto" 
                    :name="getConfig?.iconName?.value"
                />
            </div>

            <div v-if="getConfig?.headline?.value" class="font-semibold text-xl text-link">
                {{ getConfig?.headline?.value }}
            </div>
        </div>

        <div class="flex flex-col h-full justify-between">
            <div v-if="getConfig?.text?.value" class="prose max-w-none prose-headings:text-link prose-headings:font-semibold pt-4 text-lg" v-html="getConfig?.text?.value" />
    
            <div v-if="getConfig?.link?.value" class="py-3 mt-6">
                <div class="flex items-center justify-start gap-3 text-lg underline font-semibold text-placeholder-focus">
                    {{ getConfig?.linkText?.value }}

                    <MiscIcon 
                        :name="'chevron-right'"
                        :size="'lg'"
                    />
                </div>
            </div>
        </div>
    </MiscLink>
</template>

<script setup lang="ts">
import type { HblSlot } from '@/utils/types'
import { computed } from "vue";

const props = defineProps<{
    config: HblSlot
}>()

const getConfig = computed(() => {
    // @ts-ignore
    return props?.config?.config
})
</script>